import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {UiQuestionnaireLayout, Col, UiText, Row, UiButton} from '~/components/elements';
import {BlockScreenType, NONE_OF_THE_ABOVE_VALUE, WEIGHT_LOSS_KEYS} from '~/constants/medical-questionnaires';
import {setNextQuestionnaire, setQuestionnaireAnswer} from '~/redux/questionnaires/slice';
import {RootState} from '~/redux/root-reducer';
import {Option} from '~/redux/questionnaires/types';
import {useInput} from '~/hooks';
import {trackingSorryPageMisc} from '~/redux/questionnaires/thunk';

const Questionnaire13Screen = () => {
  const dispatch = useDispatch();
  const {questionnaires, wpAuthUser, mdqID} = useSelector(
    (state: RootState) => state.questionnaires.medicalQuestionnaire,
  );
  const questionnaire = questionnaires?.find(i => i.key === WEIGHT_LOSS_KEYS.FOLLOWING_APPLY);
  const currentAnswer = useSelector(
    (state: RootState) => state.questionnaires?.collectData[WEIGHT_LOSS_KEYS.FOLLOWING_APPLY]?.data,
  );
  const trackWpUserAuth = useSelector((state: RootState) => state.questionnaires.trackUserAuth);
  let medicalOptions: Option[] = [];
  if (questionnaire?.options?.length) {
    medicalOptions = questionnaire?.options?.filter(i => i?.value !== NONE_OF_THE_ABOVE_VALUE);
  }
  const methodKey = useSelector((state: RootState) => state.questionnaires.methodKey);
  const defaultOptions = medicalOptions.reduce<Record<string, boolean>>((res, cur) => {
    res[cur.value] = false;

    if (currentAnswer?.selectedOptions?.length) {
      currentAnswer?.selectedOptions.map((i: string) => {
        if (i !== NONE_OF_THE_ABOVE_VALUE) res[i] = true;
      });
    }

    return res;
  }, {});

  const resetOptions = medicalOptions.reduce<Record<string, boolean>>((res, cur) => {
    res[cur.value] = false;

    return res;
  }, {});

  const {inputs, setInputs, validation} = useInput({
    defaultOptions,
    noneOptions:
      (currentAnswer?.selectedOptions?.length && currentAnswer?.selectedOptions[0] === NONE_OF_THE_ABOVE_VALUE) ||
      false,
  });
  const dataSubmit = Object.keys(inputs.defaultOptions).filter(i => inputs.defaultOptions[i] === true);
  const onClickSubmit = async () => {
    dispatch(
      setQuestionnaireAnswer({
        key: WEIGHT_LOSS_KEYS.FOLLOWING_APPLY,
        index: questionnaire?.index || '',
        data: {selectedOptions: inputs?.noneOptions ? [NONE_OF_THE_ABOVE_VALUE] : dataSubmit},
      }),
    );
    if (!inputs?.noneOptions) {
      await dispatch(
        trackingSorryPageMisc({
          methodKey,
          screen: WEIGHT_LOSS_KEYS.BMI_ALLERGIC,
          blockScreenType: BlockScreenType.UNSUITABLE_MEDICAL_HISTORY,
          collectData: {},
          mdqKey: mdqID || '',
          wpAuthUser: trackWpUserAuth,
        }),
      );
      dispatch(setNextQuestionnaire({value: WEIGHT_LOSS_KEYS.BMI_ALLERGIC}));
      return;
    }
    dispatch(setNextQuestionnaire({value: WEIGHT_LOSS_KEYS.DESCRIBE_CURRENT_LIFESTYLE}));
  };
  const onClickOption = (answer: {value: string | number; label: string}) => {
    const {value} = answer;
    setInputs({noneOptions: false, defaultOptions: {...inputs.defaultOptions, [value]: !inputs.defaultOptions[value]}});
  };

  const onClickNoneOption = () => {
    setInputs({noneOptions: !inputs.noneOptions, defaultOptions: resetOptions});
  };

  return (
    <UiQuestionnaireLayout
      backIcon
      handleOnNext={onClickSubmit}
      actions={questionnaire?.actions}
      checkoutStep={questionnaire?.checkoutStep}
      disableNext={!dataSubmit.length && !inputs.noneOptions}
    >
      <Col align="center" textAlign="center">
        <UiText variant="mdqTitle" mt={10} mb={5}>
          {questionnaire?.questions?.default}
        </UiText>
        <UiText color="liteOuter" fontSize="14px">
          {questionnaire?.questions?.sub}
        </UiText>
        <Row justify="start" flexWrap="wrap" w="100%" mt={10}>
          {medicalOptions?.map(value => (
            <UiButton
              key={`${value.label}-${value.value}`}
              title={value.label}
              variant={inputs.defaultOptions[value.value] ? 'solid' : 'outlinePrimary'}
              onClick={() => onClickOption(value)}
              mr={2}
              fontSize={{base: '12px', md: '14px'}}
              fontWeight={600}
              mb={5}
              minH="35px"
            />
          ))}
        </Row>

        <UiButton
          onClick={onClickNoneOption}
          title="None of the above"
          variant={inputs.noneOptions ? 'solid' : 'toggle'}
          fontSize={{base: '14px', md: '16px'}}
          fontWeight={600}
          minH="48px"
          px={6}
          mt={5}
        />
      </Col>
    </UiQuestionnaireLayout>
  );
};

export default Questionnaire13Screen;
